export enum SettingsSdkKeys {
    direction = "next.ecommerce.footer.frontend.direction",
    realm = "next.ecommerce.footer.frontend.realmName",
    territory = "next.ecommerce.footer.frontend.territoryName",
    language = "next.ecommerce.footer.frontend.languageName",
    appCache = "next.ecommerce.footer.frontend.appCacheTTL",
    languageId = "next.ecommerce.footer.alternativeLanguages",
    correlationHeaderName = "x-next-correlation-id",
    sessionHeaderName = "x-next-session-id",
    cacheControl = "next.ecommerce.footer.frontend.cache-control.max-age",
    cacheControlDefaultFooter = "next.ecommerce.footer.frontend.cache-control.default-footer.max-age",
    template = "next.ecommerce.footer.frontend.template",
}

export interface SettingsModel {
    realm: string
    alignment: string
    territory: string
    language: string
}
